import "core-js/modules/es.object.assign.js";
import { h } from "vue";
//@ts-ignore
import { getDefaultSvgPropsValues } from "@vueEntry/SvgIcons/DefaultValues";
export var UkFlagIcon = function UkFlagIcon(props, _ref) {
  var attrs = _ref.attrs;
  var _a, _b;
  props = Object.assign(Object.assign({}, getDefaultSvgPropsValues()), props);
  var _props = props,
    width = _props.width,
    height = _props.height;
  return h("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16.501 11",
    width: "".concat(width),
    height: "".concat(height),
    "class": (_a = props["class"]) !== null && _a !== void 0 ? _a : "",
    "aria-hidden": (_b = attrs["aria-hidden"]) !== null && _b !== void 0 ? _b : "true"
  }, [h("defs", {
    fill: "#3d3d3d",
    d: "M0 0h16.5v3.7H0z"
  }, h("clipPath", {
    id: "a"
  }, h("path", {
    fill: "none",
    d: "M0 0h16.501v11H0z"
  }))), h("path", {
    fill: "#004493",
    d: "M0 0h16.501v11H0z"
  }), h("path", {
    fill: "#cb001e",
    d: "M0 0v2.55L14.635 11H16.5V8.807L1.246 0Z"
  }), h("g", {
    "clip-path": "url('#a')"
  }, h("path", {
    fill: "none",
    stroke: "#fff",
    "stroke-width": ".5",
    d: "m-1.651 1.309 1.18-2.042L17.92 9.899l-1.181 2.042z"
  })), h("path", {
    fill: "#cb001e",
    d: "M15.58 0 0 8.995V11h2.19L16.5 2.737V0Z"
  }), h("g", {
    "clip-path": "url(#a)"
  }, h("path", {
    fill: "none",
    stroke: "#fff",
    "stroke-width": ".5",
    d: "M-1.093 9.899 16.737-.396l1.18 2.043L.087 11.942z"
  })), h("path", {
    fill: "#cb001e",
    d: "M7.076 0v4.092H0v2.831h7.076V11h2.831V6.923H16.5V4.092H9.907V0Z"
  }), h("g", {
    "clip-path": "url(#a)"
  }, h("path", {
    fill: "none",
    stroke: "#fff",
    d: "M7.077 12.584V6.923h-8.964V4.092h8.964v-5.661h2.831v5.661h8.02v2.831h-8.02v5.661Z"
  }))]);
};